module.exports = "<div nv-l1-course-header=\"\" state-for-title=\"discussions-index\" header-title=\"{{ &quot;DISCUSSIONS.TITLE&quot; | translate }}\"></div>";